import { useMemo } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import clsx from 'clsx'

import { Text } from '@wartek-id/text'
import { Icon } from '@wartek-id/icon'

import {
  TRACKER_QUERY_SOURCE_KEY,
  TRACKER_QUERY_SOURCE_VALUE_IDE_PRAKTIK,
} from 'app/CeritaPraktikPage/constants'

import type { ListItemContainerProps } from './ListItem'
import type { FC } from 'react'
import type { TAPIInspiration } from 'types/inspirations'

interface ListItemPhotoProps
  extends React.HTMLAttributes<HTMLAnchorElement>,
    ListItemContainerProps {
  data: TAPIInspiration
}

const ListItemPhoto: FC<ListItemPhotoProps> = ({
  data,
  containerClassName,
  ...props
}) => {
  const href = useMemo(() => {
    if (
      process.env.NEXT_PUBLIC_CERITA_PRAKTIK_PAGE_ENABLED !== 'true' ||
      !data.deeplinkUrl.includes('cerita-praktik')
    ) {
      return data.deeplinkUrl
    }

    const url = new URL(data.deeplinkUrl)
    url.searchParams.set(
      TRACKER_QUERY_SOURCE_KEY,
      TRACKER_QUERY_SOURCE_VALUE_IDE_PRAKTIK
    )

    return url.toString()
  }, [data.deeplinkUrl])

  return (
    <Link href={href} passHref>
      <a {...props}>
        <div className={clsx(['p-4', containerClassName])}>
          <div className="flex flex-row items-start justify-between space-x-3">
            <div className="flex flex-col w-full space-y-1 break-words">
              {/* Title */}
              <Text
                color="default"
                variant="heading-sm"
                className="overflow-wrap-anywhere line-clamp-3"
              >
                {data?.title}
              </Text>

              {/* Description */}
              {/* {data?.description && (
                <Text color="default" variant="body" className="line-clamp-4">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Pellentesque magna tellus, molestie in nisi at, varius
                  tincidunt nibh. Nulla eget consequat ante. Fusce volutpat
                  laoreet magna ut fringilla. Curabitur sollicitudin erat vitae
                  nisi semper, ac sodales diam tempus. Donec at luctus tellus,
                  nec cursus purus.
                </Text>
              )} */}

              {/* Creator Name */}
              <Text
                color="subdued"
                variant="helper"
                className="line-clamp-1 !mt-2"
              >
                {data?.creatorName || 'KEMENDIKBUD RI'}
              </Text>
            </div>

            <div className="relative flex-shrink-0">
              {['CS_BUKTI_KARYA', 'CS_VIDEO_INSPIRASI'].includes(
                data.contentSource
              ) && (
                <div className="absolute top-0 bottom-0 left-0 right-0 z-10 flex items-center justify-center">
                  <Icon color="inverse" fontSize="large">
                    play_circle
                  </Icon>
                </div>
              )}
              <Image
                width={80}
                height={80}
                className="w-[80px] h-[80px] object-cover rounded"
                src={data.thumbnail}
                alt=""
                unoptimized
              />
            </div>
          </div>
        </div>
      </a>
    </Link>
  )
}
export default ListItemPhoto
